import React from "react";
import Select from "react-select";

const pricingOptions = [
  { value: "One time payment", label: "One time payment" },
  { value: "Subscription", label: "Subscription" },
  { value: "Per service", label: "Per service" },
  { value: "Custom", label: "Custom" },
];

const paymentOptions = [
  { value: "UPI", label: "UPI" },
  { value: "Venmo", label: "Venmo" },
  { value: "Bank transfer", label: "Bank transfer" },
  { value: "Credit card via", label: "Credit card via" },
  { value: "Cash", label: "Cash" },
];

function BusinessPricingDetails({
  pricingModel,
  setPricingModel,
  pricingAmount,
  setPricingAmount,
  paymentMethods,
  setPaymentMethods,
}) {
  return (
    <div className="Business-container mt-4">
      <h2>Pricing Details</h2>

      <div className="field">
        <label>Pricing model</label>

        <Select
          options={pricingOptions}
          value={pricingOptions.find(
            (item) => item.value === pricingModel
          )}
          onChange={(option) => setPricingModel(option.value)}
          placeholder="Select Pricing Model"
          classNamePrefix="business-select"
        />
      </div>

      <div className="field">
        <label>Pricing amount and details</label>

        <input
          type="text"
          placeholder="$12 per 15 matches"
          value={pricingAmount}
          onChange={(e) => setPricingAmount(e.target.value)}
        />
      </div>

      <div className="field">
        <label>Payment methods supported</label>

        <Select
          isMulti
          options={paymentOptions}
          value={paymentMethods}
          onChange={(selected) => setPaymentMethods(selected)}
          placeholder="Select payment methods"
          classNamePrefix="business-select"
        />
      </div>
    </div>
  );
}

export default BusinessPricingDetails;